import { render, staticRenderFns } from "./ScriptView.vue?vue&type=template&id=3b3be433&scoped=true"
import script from "./ScriptView.vue?vue&type=script&lang=js"
export * from "./ScriptView.vue?vue&type=script&lang=js"
import style0 from "./ScriptView.vue?vue&type=style&index=0&id=3b3be433&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3be433",
  null
  
)

export default component.exports